<template>
  <TabPanels class="h-full grow overflow-auto">
    <slot />
  </TabPanels>
</template>

<script setup lang="ts">
import { TabPanels } from '@headlessui/vue';
// This one is just for consistency
</script>
